const en_supplychain_itemReq = {
    add: "add item request",
    edit: "edit item request",
    detail: "item request detail",

    label: {
        date_target: "Target Delivery Date",
        up_img: "Upload Image",
        btn_po: "create PO",
        btn_so: "create SO",
        btn_do: "create DO",
        goods_id: "Item ID",

        view_title: "ITEM REQUEST LETTER",
    },

    error: {
        create: "Failed to create item request",
        detail_data: "Item data cannot be empty",
        detail_min: "At least 1 item is required",
        detail_up: "Please wait until file upload is completed",
        img_up: "Failed to upload image",
        img_up_size: "File size must not exceed 16MB",
        edit: "Failed to update item request",
    },

    success: {
        create: "Item request created successfully",
        edit: "Item request updated successfully",
    },

    message: {
        conf_finish_title: "Are you sure you want to complete this request?",
        conf_finish_text: "Enter reason for completing the request",

        reject_title: "Are you sure you want to cancel this request?",
        reject_text: "Enter reason for cancelling the request",
    },
}

export default en_supplychain_itemReq;